import React, { PureComponent } from 'react';
//import PropTypes from 'prop-types';
import { Modal } from 'antd';

class MyModalError extends PureComponent {

    state = {
        interval: 10,
        currentCount: 10
    }

    timer() {
        this.setState({
            currentCount: this.state.currentCount - 1
        });

        if (this.state.currentCount < 1) {
            this.resetLokalSetting();
            clearInterval(this.intervalId);
            // this.props.onAction();
            // this.props.onOk();
            window.location.reload();
        }
    }

    resetLokalSetting = () => {
        let lokalSetting = localStorage.getItem('configApp');
        if (typeof lokalSetting != 'undefined') {
            localStorage.removeItem('configApp');
        }
    }

    componentDidUpdate = () => {
    }

    componentDidMount() {
        this.intervalId = setInterval(this.timer.bind(this), 1000);
    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    render() {
        const { visible, onOk, onCancel, title, content } = this.props;
        return (
            <div>
                <Modal
                    title={title ? title : "Pesan Error"}
                    visible={visible}
                    onOk={onOk}
                    onCancel={onCancel}
                >
                    {/* <p>Koneksi server gagal!</p> */}
                    <p>{content ? content : "Koneksi server gagal!"} Koneksi Ulang pada {this.state.currentCount} detik</p>
                </Modal>
            </div>
        );
    }
}

MyModalError.propTypes = {

};

export default MyModalError;